import { Injectable } from '@angular/core';

import { HttpClient } from '../_services/global-http.service';
import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operators';
import { PaginationParams } from '../_models/generic';
import { VehicleGroupAdminPaginationApi, IVehicleGroupForUserListPaginationApi } from '../_models/vehicle';
import { Utilities } from '../_utilities/Utilities';

@Injectable()
export class VehiclesGroupsService {
  constructor(private http: HttpClient) { }

  data: any;

  getVehiclesGroups(params: PaginationParams) {
    this.data = this.http.get('/api/vehicles_groups/', { params: params });
    return this.data;
  }

  getVehiclesGroupsOnlyTrackers(params: PaginationParams) {
    this.data = this.http.get('/api/collapsible/track/', { params: params });
    return this.data;
  }

  getDriverGroups(params: PaginationParams) {
    this.data = this.http.get('/api/collapsible/driver/track/', { params: params });
    return this.data;
  }

  findAdminVehicles(params: PaginationParams): Observable<VehicleGroupAdminPaginationApi> {
    const _params = Utilities.convertPaginationParameters(params);
    return this.http.get<VehicleGroupAdminPaginationApi>('/api/administration/vehicles_groups/', { params: _params });
  }
  getAdminVehicleGroups(params: PaginationParams) {
    this.data = this.http.get('/api/administration/vehicles_groups/', { params: params });
    return this.data;
  }

  getVehiclesGroupsForUserList(params: PaginationParams): Observable<IVehicleGroupForUserListPaginationApi> {
    const _params = Utilities.convertPaginationParameters(params);
    return this.http.get<IVehicleGroupForUserListPaginationApi>('/api/vehicles_groups_for_user_list/', { params: _params });
  }

  getVehicleGroup(vehicleGroupId: number) {
    this.data = this.http.get('/api/vehicles_group/' + vehicleGroupId + '/');
    return this.data;
  }

  getVehicleGroupsByVehicle(vehicleId: number) {
    this.data = this.http.get('/api/vehicle/' + vehicleId + '/vehicle_groups');
    return this.data;
  }


  postAddVehicleGroups(newVehicleGroups: any) {
    let apiAddNewVehicleGroups = '/api/vehicles_groups/';
    this.data = this.http.post(apiAddNewVehicleGroups, newVehicleGroups);
    return this.data;
  }

  removeVehicleGroups(id: any) {
    this.data = this.http.post('/api/vehicles_groups_delete/', id);
    return this.data;
  }

  putUpdateVehicleGroups(updateVehicleGroups: any, id: number) {
    let apiUpdateVehicleGroups = '/api/vehicles_group/' + id + '/';
    this.data = this.http.put(apiUpdateVehicleGroups, updateVehicleGroups);
    return this.data;
  }

  getMultiselectRegionsList(params: PaginationParams): Observable<IVehicleGroupForUserListPaginationApi> {
    const _params = Utilities.convertPaginationParameters(params);
    return this.http.get<IVehicleGroupForUserListPaginationApi>('/api/regions_multiselect_list/', { params: _params });

  }


}



// WEBPACK FOOTER //
// /Users/brianyoung/Documents/Development/hfg/datalive-core/gae-web/datalive/client/src/app/_services/vehicles-groups.service.ts